export default "__VITE_ASSET__WvGnFMZr__"